import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";
import { CorporateNameInputMeta } from "@Shared/containers/form/commonMeta";

export interface IAboutFormMeta {
  id: FormInputMeta;
  bank: FormInputMeta;
  agency: FormInputMeta;
  creationDate: FormInputMeta;
  type: FormInputMeta;
  vipCategory: FormInputMeta;
  solvabilityLevel: FormInputMeta;
  status: FormInputMeta;
  parentCustomer: FormInputMeta;
  familyRelationship: FormInputMeta;
  promotor: FormInputMeta;

  schema: any;
}

const aboutFormMeta = {} as IAboutFormMeta;

aboutFormMeta.id = {
    name: "id",
    type: "text",
    label: "ID",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

aboutFormMeta.bank = {
    ...CorporateNameInputMeta,
    name: "bank",
    type: "select",
    label: "Banque",
};

aboutFormMeta.agency = {
    name: "agency",
    type: "select",
    label: "Agence",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

aboutFormMeta.creationDate = {
    name: "creationDate",
    type: "date",
    label: "Date Créatiion",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

aboutFormMeta.type = {
    name: "type",
    type: "select",
    label: "Type",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

aboutFormMeta.vipCategory = {
    name: "vipCategory",
    type: "select",
    label: "Catégorie VIP",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

aboutFormMeta.solvabilityLevel = {
    name: "solvabilityLevel",
    type: "select",
    label: "Niveau Solvabilité",
    placeholder: "",
    validation: yup.string()
};

aboutFormMeta.status = {
    name: "status",
    type: "select",
    label: "Statut",
    placeholder: "",
    validation: yup.string()
};

aboutFormMeta.parentCustomer = {
    name: "parentCustomer",
    type: "select",
    label: "Parent Client",
    placeholder: "",
    validation: yup.string()
};

aboutFormMeta.familyRelationship = {
    name: "familyRelationship",
    type: "select",
    label: "Lien de Parenté",
    placeholder: "",
    validation: yup.string()
};

aboutFormMeta.promotor = {
    name: "promotor",
    type: "text",
    label: "Promoteur",
    placeholder: "",
    validation: yup.string()
};

aboutFormMeta.schema = yup.object().shape(getValidationSchema(aboutFormMeta));

export default aboutFormMeta;